import { SeasonTab, SeasonUrlState } from '@/types';
import { serializeSeasonUrl } from './seasonUrlState';

export const seasonKeys = {
  all: (workspaceId: string) => ['season-v2', workspaceId] as const,
  seasons: (workspaceId: string) => [...seasonKeys.all(workspaceId), 'seasons'] as const,
  section: (workspaceId: string, section: SeasonTab, state: SeasonUrlState) => (
    [...seasonKeys.all(workspaceId), section, serializeSeasonUrl(state).toString()] as const
  ),
};

export const isSeasonStandingsKey = (queryKey: readonly unknown[], workspaceId: string, season: number): boolean => {
  if (queryKey[0] !== 'season-v2' || queryKey[1] !== workspaceId || queryKey[2] !== 'standings' || typeof queryKey[3] !== 'string') return false;
  const encoded = new URLSearchParams(queryKey[3]);
  return encoded.get('season') === String(season);
};
